import { apiFetch } from "./apiClient";
import CONFIG from "../config";

export async function listGatewayTargets() {
  const response = await apiFetch(`${CONFIG.apiUrl}api/gateway/targets`);
  return response.targets || [];
}

export async function getGatewayTarget(targetId) {
  return apiFetch(`${CONFIG.apiUrl}api/gateway/targets/${encodeURIComponent(targetId)}`);
}

export async function createGatewayTarget(data) {
  return apiFetch(`${CONFIG.apiUrl}api/gateway/targets`, { method: "POST", body: JSON.stringify(data) });
}

export async function updateGatewayTarget(targetId, data) {
  return apiFetch(`${CONFIG.apiUrl}api/gateway/targets/${encodeURIComponent(targetId)}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteGatewayTarget(targetId) {
  return apiFetch(`${CONFIG.apiUrl}api/gateway/targets/${encodeURIComponent(targetId)}`, { method: "DELETE" });
}

export async function syncGatewayTarget(targetId) {
  return apiFetch(`${CONFIG.apiUrl}api/gateway/targets/${encodeURIComponent(targetId)}/sync`, { method: "POST" });
}
